import { useMemo } from 'react';

import { PERMISSIONS, usePlatformAuthorization } from '@/lib/auth';

export const useChannelRecordingsPermissions = () => {
  const { hasPlatformPermission } = usePlatformAuthorization();

  const { canCreate, canDuplicate, canCancel } = useMemo(
    () => ({
      canCreate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_CHANNEL_RECORDING]),
      canDuplicate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_CHANNEL_RECORDING]),
      canCancel: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.DELETE_CHANNEL_RECORDING]),
    }),
    [hasPlatformPermission]
  );

  return {
    canCreate,
    canDuplicate,
    canCancel,
  };
};
